/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';
import "./NotFound.scss";
import Helper from '../../../core/libraries/Helper';
import Constants from '../../../core/libraries/Constants';
import { SupportEmailTemplate } from '../../../core/libraries/Template';

class NotFound extends React.Component<any, any> {

    render() {
        return (
            <div className="display">
                <h1 style={{ textAlign: 'center' }}>404 Not Found</h1>
                <p className="zoom-area">Report with ID - <b>{this.props.id}</b> not found in FEBER system. </p>
                <section className="error-container">
                    <span className="four"><span className="screen-reader-text">4</span></span>
                    <span className="zero"><span className="screen-reader-text">0</span></span>
                    <span className="four"><span className="screen-reader-text">4</span></span>
                </section>
                <div className="link-container">
                    <a onClick={(event: any) => {
                        event.preventDefault();
                        Helper.openOutlookForSupport(Constants.FEBER_MAILBOX_ADDRESS, Constants.SUPPORT_SUBJECT, SupportEmailTemplate)
                    }} href='#' 
                    className="more-link">Ask for help</a>
                </div>
            </div>
        );
    }
}

export default NotFound;